

angular
.module('inkfinder')
.factory('Conversations', function Conversations(
  $q,
  $http,
  ENDPOINT,
  AlertMessages,
  filterFilter,
  Session
) {
  Conversations.get = get;
  Conversations.getBatch = getBatch;

  /**
   * @name get
   * @description Function to get a conversation from the api
   * @param {number} id The ID number of the converstation to retrieve
   * @return {object} data Returns the conversation object.
   */
  function get(id) {
    let url = ENDPOINT.server + 'conversations/api/v1.1/' + id + '/';
    let role = Session.activeState.role;
    url += '?role=' + role;
    return $http.get(url).then(function(response) {
      Conversations.conversation = response.data;
      return response.data;
    }, function(error) {
      AlertMessages.add({
        msg: error,
        type: 'danger'
      });
    });
  }

  /**
   * @name getBatch
   * @description Function to get a conversation from the api
   * @param {number} ids The ID number of the converstation to retrieve
   * @return {object} data Returns the conversation object.
   */
  function getBatch(ids) {
    let url = ENDPOINT.server + 'conversations/api/v1.1/?ids=' + ids.toString();
    let role = Session.activeState.role;
    url += '&role=' + role;
    return $http.get(url).then(function(response) {
      Conversations.conversation = response.data;
      return response.data;
    }, function(error) {
      AlertMessages.add({
        msg: error,
        type: 'danger'
      });
    });
  }
  return Conversations;
});



// WEBPACK FOOTER //
// ./components/messages/conversations/conversations.service.js